// extracted by mini-css-extract-plugin
export default {"tagsSection":"TagsSection-module__tagsSection--QQZb6","categories":"TagsSection-module__categories--fAjZL"};